export default __webpack_public_path__ + "static/mmoparties-012c4dcdaa42f0a5a02d3913b5a37f86.png";